import { useCallback, useEffect } from "react";
import LandingHeader from "./components/LandingHeader";
import HeroSection from "./components/HeroSection";
import AboutSolutionsSection from "./components/AboutSolutionsSection";
import AudienceSection from "./components/AudienceSection";
import FeaturesSection from "./components/FeaturesSection";
import ProcessSection from "./components/ProcessSection";
import LandingFooter from "./components/LandingFooter";

export default function LandingPage() {
  const handleNavigate = useCallback((href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    // Update page title for SEO
    document.title = "FloraIQ — Inteligência Ambiental para Cidades Mais Verdes e Inteligentes";
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <LandingHeader onNavigate={handleNavigate} />
      <HeroSection />
      <AboutSolutionsSection />
      <AudienceSection />
      <FeaturesSection />
      <ProcessSection />
      <LandingFooter />
    </div>
  );
}